module.exports = __webpack_public_path__ + "static/media/finish.0a3dce4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/finish.mp3
// module id = r9A6
// module chunks = 0